import { ReactComponent as FloppyDiskIcon } from 'assets/icons/floppy_disk.svg';
import styled, { keyframes } from 'styled-components/macro';

import ButtonShadow from '../animations/ButtonShadow';
import BackButton from '../common/BackButton';

export const StatusScreenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: 100%;
`;

export const Header = styled.div<{ sizeRatio: number }>`
  padding: ${({ sizeRatio }) => `${sizeRatio * 15}px ${sizeRatio * 25}px`};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.h3<{ sizeRatio: number }>`
  font-size: ${({ sizeRatio }) => `${sizeRatio * 19}px`};
  font-family: 'Presicav';
  margin: 0;
`;

export const Back = styled(BackButton)`
  cursor: none;
  align-self: flex-end;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    cursor: pointer;
    align-self: flex-start;
  `};
`;

export const Content = styled.div<{ sizeRatio: number }>`
  width: 100%;
  padding: ${({ sizeRatio }) => `${sizeRatio * 15}px ${sizeRatio * 25}px`};
`;

export const StatusRowWrapper = styled.div<{ sizeRatio: number }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${({ sizeRatio }) => `${sizeRatio * 15}px 0px`};
`;
export const StatusRowTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StatusRowTitle = styled.h4<{ sizeRatio: number }>`
  font-family: 'Presicav';
  font-size: ${({ sizeRatio }) => `${sizeRatio * 15}px`};
  margin: 0;
`;

export const StatusRowUser = styled.div<{ sizeRatio: number }>`
  padding-top: 0.4rem;
  font-size: ${({ sizeRatio }) => `${sizeRatio * 13}px`};
`;

export const AuthBtnWrapper = styled.div``;
export const AuthBtn = styled.button<{ sizeRatio: number }>`
  font-family: 'Presicav';
  cursor: none;
  outline: none;
  border: 2px solid white;
  background: none;
  color: white;
  border-radius: 5px;
  font-weight: bold;
  padding: ${({ sizeRatio }) => `${sizeRatio * 1}px ${sizeRatio * 13}px`};
  font-size: ${({ sizeRatio }) => `${sizeRatio * 11}px`};
  animation: ${ButtonShadow} 1.6s infinite;
`;

export const StatusActionWrapper = styled.div<{ sizeRatio: number }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ sizeRatio }) => `0px ${sizeRatio * 15}px ${sizeRatio * 25}px ${sizeRatio * 15}px`};
`;

const InteractAnim = keyframes`
  0% {
    opacity: 1;

  }
  50% {
    opacity: 0.7;
  
  }
  100% {
    opacity: 1;
  
  }
`;

export const GeneratebtnWrapper = styled.div`
  animation: ${InteractAnim} 1.5s infinite;
`;
export const GenerateBtn = styled.button<{ sizeRatio: number }>`
  font-family: 'Presicav';
  cursor: none;
  outline: none;
  border: 2px solid white;
  background: none;
  color: white;
  border-radius: 5px;
  font-weight: bold;
  padding: ${({ sizeRatio }) => `${sizeRatio * 1}px ${sizeRatio * 13}px`};
  font-size: ${({ sizeRatio }) => `${sizeRatio * 16}px`};
  animation: ${ButtonShadow} 1.6s infinite;
`;

export const GeneratingWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
`;

interface SvgStyledProps {
  className?: string;
  sizeRatio?: number;
}

export const FloppyDisk = styled(({ sizeRatio, ...props }) => <FloppyDiskIcon {...props} />)<SvgStyledProps>`
  height: ${({ sizeRatio }) => `${(sizeRatio ?? 1) * 35}px`};
  margin-right: 5px;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    height: 30px;
  `};
`;

export const ProgressWrapper = styled.div`
  width: 100%;
`;

export const GeneratingLabel = styled.div`
  font-size: 0.8rem;
  padding-bottom: 5px;
  font-weight: bold;
  font-family: 'Presicav';
`;

export const LoadingBarWrapper = styled.div<{ sizeRatio: number }>`
  width: 100%;
  border: 2px solid white;
  height: ${({ sizeRatio }) => `${sizeRatio * 18}px`};
  padding: 1px;
`;

const fillbar = keyframes`
  from{width: 0%;}
  to {width: 100%;}
`;

export const LoadingBar = styled.div`
  background-color: white;
  height: 100%;
  width: 100%;
  animation: ${fillbar} 3s linear;
`;
